const getIrudizIdParam = data => data?.irudiz?.id

export default getIrudizIdParam